import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { signIn, changePassword } from 'src/redux/actions/user';
import { getLocale, getUser } from 'src/redux/selectors';
import { findAllSites } from 'src/redux/actions/sites';
import changeLocale from 'src/redux/actions/locale';

class SignIn extends Component {
  render = () => {
    const {
      Layout,
      signIn,
      changePassword,
      user,
      push,
      sites,
      findAllSites
    } = this.props;

    return (
      <Layout
        signIn={signIn}
        changePassword={changePassword}
        user={user}
        push={push}
        sites={sites}
        findAllSites={findAllSites}
      />
    );
  };
}

const mapStateToProps = state => ({
  user: getUser(state),
  sites: state.sites.allSites || []
});

const mapDispatchToProps = {
  signIn,
  changePassword,
  push,
  findAllSites
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignIn);
